import { FieldArray, useFormikContext } from 'formik';
import Accordion from '../../../../components/Accordion/Accordion';
import Button from '../../../../components/Button/Button';
import '../BackofficeMaterial.scss';
import { useState, useEffect } from 'react';
import { IFormikBOMUpdate } from '../IBackofficeMaterial';
import { FormikInput } from './FormikInput';
import { IPhysicalDataResponse } from '../../../api/IApiResponse';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import { useTranslation } from 'react-i18next';
import { conversionLabel } from '../../../conversion';
import { selectProjectInfo } from '../../../store/projectInfo/projectInfoSlice';
import { useAppSelector } from '../../../../reduxService/hooks';
interface IFormikPhysicalDataProps {}

export const FormikPhysicalData = (props: IFormikPhysicalDataProps) => {
    const projectInfo = useAppSelector(selectProjectInfo);
    const [withCu, setWithCu] = useState<boolean>(false);
    const { values, handleChange, setFieldValue } = useFormikContext<IFormikBOMUpdate>();
    const { t } = useTranslation();

    useEffect(() => {
        if (!!values.physicalData && !!values.physicalData.length) {
            let firstPd = values.physicalData[0];
            setWithCu(!!firstPd.cu);
        }
    }, []);

    return (
        <>
            <FieldArray
                name='physicalData'
                render={arrayHelpers => (
                    <>
                        {values.physicalData.map((data, index) => {
                            let title;
                            if (!data.id) title = `New ${index}`;
                            else {
                                if (withCu) title = `T: ${data.thickness}, D50: ${data.rockD50}, CU: ${data.cu}`;
                                else title = `T: ${data.thickness}, D50: ${data.rockD50}`;
                            }
                            return (
                                <Accordion title={title} key={`Data${data.id}`}>
                                    <div className='d-flex flex-column gap-1'>
                                        <FormikInput
                                            label={t('bo_material_input_thickness', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}
                                            name={`physicalData.${index}.thickness`}
                                            type='number'
                                        />
                                        <FormikInput
                                            label={t('bo_material_input_rockD50', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}
                                            name={`physicalData.${index}.rockD50`}
                                            type='number'
                                        />
                                        {withCu && <FormikInput label={t('bo_material_input_cu')} name={`physicalData.${index}.cu`} type='number' />}

                                        <FormikInput
                                            label={t('bo_material_input_shearstress', { unit_measure: conversionLabel.Nm2_lbfft2[projectInfo.data?.unitOfMeasure as number] })}
                                            name={`physicalData.${index}.allowShearStress`}
                                            type='number'
                                            step={0.01}
                                        />
                                        <FormikInput label={t('bo_material_input_roughness')} name={`physicalData.${index}.roughness`} type='number' step={0.0001} />
                                        <FormikInput
                                            label={t('bo_material_input_shearstress_vert', { unit_measure: conversionLabel.Nm2_lbfft2[projectInfo.data?.unitOfMeasure as number] })}
                                            name={`physicalData.${index}.allowedShearStressVert`}
                                            type='number'
                                            step={0.01}
                                        />

                                        <Checkbox
                                            title='Default'
                                            name={`physicalData.${index}.isDefault`}
                                            defaultChecked={data.isDefault}
                                            checked={data.isDefault}
                                            onChange={e => {
                                                handleChange(e);
                                                values.physicalData.forEach((pd, i) => {
                                                    if (index !== i) setFieldValue(`physicalData.${i}.isDefault`, false);
                                                });
                                            }}
                                        />
                                        <Button className='d-flex justify-content-end' classNameBtn='btn-color-icon-delete' onClick={() => arrayHelpers.remove(index)}>
                                            <i className='fa-solid fa-trash' />
                                        </Button>
                                    </div>
                                </Accordion>
                            );
                        })}
                        <Button
                            className='d-flex justify-content-end pt-2'
                            classNameBtn='btn-color-inverted'
                            onClick={() => {
                                let emptyPd: IPhysicalDataResponse = { thickness: 0, roughness: 0, isDefault: false, rockD50: 0, allowShearStress: 0, allowedShearStressVert: 0 };
                                if (withCu) emptyPd = { ...emptyPd, cu: 0 };
                                arrayHelpers.push(emptyPd);
                            }}>
                            <i className='fa-solid fa-plus' />
                        </Button>
                    </>
                )}
            />
        </>
    );
};
